module.exports = __webpack_public_path__ + "img/ElectricCopperCombs.c542a58b.png";